module.exports = __webpack_public_path__ + "static/media/Karthik-headshot-2022-256.e766e05a.webp";